/**
 * @generated SignedSource<<351fa5738dfef426236fd7c0cebce2fa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeleteElementInput = {
  clientMutationId?: string | null;
  elementId: string;
};
export type ElementBase_DeleteElement_Mutation$variables = {
  input: DeleteElementInput;
};
export type ElementBase_DeleteElement_Mutation$data = {
  readonly deleteElement: {
    readonly screener: {
      readonly elements: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly " $fragmentSpreads": FragmentRefs<"ActiveElementContent_element">;
          } | null;
        } | null>;
      } | null;
      readonly id: string;
    } | null;
  } | null;
};
export type ElementBase_DeleteElement_Mutation = {
  response: ElementBase_DeleteElement_Mutation$data;
  variables: ElementBase_DeleteElement_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "target",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "target2",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "targetTypes",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "responseValidation",
  "storageKey": null
},
v8 = [
  (v2/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "position",
  "storageKey": null
},
v10 = [
  (v2/*: any*/),
  (v9/*: any*/),
  (v3/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "randomize",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "terminate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ElementBase_DeleteElement_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteElementPayload",
        "kind": "LinkedField",
        "name": "deleteElement",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ScreenerNode",
            "kind": "LinkedField",
            "name": "screener",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ElementNodeConnection",
                "kind": "LinkedField",
                "name": "elements",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ElementNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ElementNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ActiveElementContent_element"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ElementBase_DeleteElement_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteElementPayload",
        "kind": "LinkedField",
        "name": "deleteElement",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ScreenerNode",
            "kind": "LinkedField",
            "name": "screener",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ElementNodeConnection",
                "kind": "LinkedField",
                "name": "elements",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ElementNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ElementNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AssetNode",
                            "kind": "LinkedField",
                            "name": "asset",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "url",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "label",
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "usePreviousAnswers",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ScreenerNode",
                            "kind": "LinkedField",
                            "name": "screener",
                            "plural": false,
                            "selections": (v8/*: any*/),
                            "storageKey": null
                          },
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CharacteristicNode",
                            "kind": "LinkedField",
                            "name": "characteristic",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CharacteristicAnswerNode",
                                "kind": "LinkedField",
                                "name": "answers",
                                "plural": true,
                                "selections": (v10/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CharacteristicElementMetaNode",
                                "kind": "LinkedField",
                                "name": "elementMeta",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  (v7/*: any*/),
                                  (v4/*: any*/),
                                  (v5/*: any*/),
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "importKey",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "shortName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TenantNode",
                                "kind": "LinkedField",
                                "name": "tenant",
                                "plural": false,
                                "selections": (v8/*: any*/),
                                "storageKey": null
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AnswerNodeConnection",
                            "kind": "LinkedField",
                            "name": "answers",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AnswerNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AnswerNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "dbId",
                                        "storageKey": null
                                      },
                                      (v9/*: any*/),
                                      (v3/*: any*/),
                                      (v12/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "quota",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "other",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "rating",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "exclusive",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "userSpecified",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "terminateCondition",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RowNodeConnection",
                            "kind": "LinkedField",
                            "name": "rows",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RowNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RowNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v10/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "showIfCondition",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GridAnswerNode",
                            "kind": "LinkedField",
                            "name": "gridAnswers",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RowNode",
                                "kind": "LinkedField",
                                "name": "row",
                                "plural": false,
                                "selections": (v8/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AnswerNode",
                                "kind": "LinkedField",
                                "name": "answer",
                                "plural": false,
                                "selections": (v8/*: any*/),
                                "storageKey": null
                              },
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "goal",
                                "storageKey": null
                              },
                              (v12/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "213876096143c4d298aa0166b5c324da",
    "id": null,
    "metadata": {},
    "name": "ElementBase_DeleteElement_Mutation",
    "operationKind": "mutation",
    "text": "mutation ElementBase_DeleteElement_Mutation(\n  $input: DeleteElementInput!\n) {\n  deleteElement(input: $input) {\n    screener {\n      id\n      elements {\n        edges {\n          node {\n            ...ActiveElementContent_element\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ActiveElementContent_element on ElementNode {\n  id\n  text\n  asset {\n    id\n    url\n  }\n  type\n  label\n  target\n  target2\n  targetTypes\n  responseValidation\n  usePreviousAnswers\n  screener {\n    id\n  }\n  position\n  characteristic {\n    answers {\n      id\n      position\n      text\n    }\n    elementMeta {\n      randomize\n      responseValidation\n      target\n      target2\n      targetTypes\n    }\n    importKey\n    shortName\n    tenant {\n      id\n    }\n    id\n  }\n  answers {\n    edges {\n      node {\n        id\n        dbId\n        position\n        text\n        ...Option_answer\n      }\n    }\n  }\n  rows {\n    edges {\n      node {\n        id\n        position\n        text\n        ...Row_row\n      }\n    }\n  }\n  randomize\n  showIfCondition\n  ...AddOption_element\n  ...GridQuestionEditor_element\n  ...InputFilterGroupGroup_element\n  ...Option_element\n  ...Row_element\n  ...UsePreviousAnswers_element\n}\n\nfragment AddOption_element on ElementNode {\n  id\n  type\n  answers {\n    edges {\n      node {\n        id\n        text\n        terminate\n        quota\n        other\n        position\n      }\n    }\n  }\n}\n\nfragment GridQuestionEditor_element on ElementNode {\n  id\n  usePreviousAnswers\n  characteristic {\n    importKey\n    id\n  }\n  answers {\n    edges {\n      node {\n        id\n        position\n        terminate\n        text\n      }\n    }\n  }\n  rows {\n    edges {\n      node {\n        id\n        text\n        position\n      }\n    }\n  }\n  gridAnswers {\n    row {\n      id\n    }\n    answer {\n      id\n    }\n    id\n    goal\n    terminate\n  }\n}\n\nfragment InputFilterGroupGroup_element on ElementNode {\n  id\n  ...InputFilterGroup_element\n}\n\nfragment InputFilterGroup_element on ElementNode {\n  id\n  ...InputFilter_element\n}\n\nfragment InputFilter_element on ElementNode {\n  position\n}\n\nfragment OptionTerminate_answer on AnswerNode {\n  terminate\n  terminateCondition\n}\n\nfragment OptionTerminate_element on ElementNode {\n  type\n  answers {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n\nfragment Option_answer on AnswerNode {\n  id\n  text\n  terminate\n  quota\n  other\n  rating\n  exclusive\n  userSpecified\n  position\n  ...OptionTerminate_answer\n}\n\nfragment Option_element on ElementNode {\n  id\n  type\n  usePreviousAnswers\n  characteristic {\n    importKey\n    tenant {\n      id\n    }\n    id\n  }\n  ...OptionTerminate_element\n}\n\nfragment Row_element on ElementNode {\n  type\n  characteristic {\n    id\n  }\n}\n\nfragment Row_row on RowNode {\n  id\n  text\n}\n\nfragment UsePreviousAnswers_element on ElementNode {\n  id\n  usePreviousAnswers\n}\n"
  }
};
})();

(node as any).hash = "cb97a459f850a2a7ce24eca958daf901";

export default node;
